module.exports = __webpack_public_path__ + "img/slide2.c61f6fd9.jpg";